export const JobCategoryNames = {
    QUICK_HAUL: 'Quick Haul',
    RECYCLE: 'Recycle',
    YARD_DEBRIS: 'Yard Debris',
    JUNK: 'Junk'
}



// WEBPACK FOOTER //
// ./src/constants/jobCategoryNames.ts